import { render, staticRenderFns } from "./App-block-key.vue?vue&type=template&id=25a48641&scoped=true&"
import script from "./App-block-key.vue?vue&type=script&lang=ts&"
export * from "./App-block-key.vue?vue&type=script&lang=ts&"
import style0 from "./App-block-key.vue?vue&type=style&index=0&id=25a48641&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a48641",
  null
  
)

export default component.exports